import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid,
} from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon } from "@mui/icons-material";
import BASE_URL from "../config";

const RoutePage = () => {
  const [routeName, setRouteName] = useState("");
  const [fee, setFee] = useState("");
  const [feeCategory, setFeeCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [editingRoute, setEditingRoute] = useState(null);
  const storedName = sessionStorage.getItem('adminName');
  useEffect(() => {
    fetchCategories();
    fetchRoutes();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/getNonRegularCategories`);
      setCategories(res.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchRoutes = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/getRoutes`);
      setRoutes(res.data);
    } catch (error) {
      console.error("Error fetching routes:", error);
    }
  };

  const handleSaveOrUpdate = async () => {
    if (!routeName || !fee || !feeCategory) {
      alert("All fields are required!");
      return;
    }

    const routeData = {
      routeName,
      fee,
      categoryID: feeCategory,
      //createdBy: storedName,
      //updatedBy: storedName,
    };

    try {
      if (editingRoute) {
        routeData.routeID = editingRoute.RouteID;
        routeData.updatedBy = storedName; // Store the admin who updated
        const res = await axios.put(`${BASE_URL}/api/updateRoute`, routeData);
        alert(res.data.message);
        setEditingRoute(null);
      } else {
        routeData.createdBy = storedName; // Store the admin who created
        const res = await axios.post(`${BASE_URL}/api/addRoute`, routeData);
        alert(res.data.message);
      }
      setRouteName("");
      setFee("");
      setFeeCategory("");
      fetchRoutes();
    } catch (error) {
      alert("Error saving/updating route");
    }
  };

  const handleEdit = (route) => {
    setEditingRoute(route);
    setRouteName(route.RouteName);
    setFee(route.Fee);
    setFeeCategory(route.CategoryID);
     /* window.scrollTo({ top: 0, behavior: "smooth" }); */
     const container = document.querySelector('#root');
     container.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (routeID) => {
    if (window.confirm("Are you sure you want to delete this route?")) {
      try {
        const res = await axios.delete(`${BASE_URL}/api/deleteRoute/${routeID}`);
        alert(res.data.message);
        fetchRoutes();
      } catch (error) {
        alert("Error deleting route");
      }
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Card sx={{ p: 4, boxShadow: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Manage  Fee Routes
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Route Name"
              value={routeName}
              onChange={(e) => setRouteName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Fee"
              type="number"
              value={fee}
              onChange={(e) => setFee(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Fee Category"
              value={feeCategory}
              onChange={(e) => setFeeCategory(e.target.value)}
            >
              <MenuItem value="">Select Category</MenuItem>
              {categories.map((cat) => (
                <MenuItem key={cat.CategoryID} value={cat.CategoryID}>
                  {cat.CategoryName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              color={editingRoute ? "warning" : "primary"}
              onClick={handleSaveOrUpdate}
              startIcon={editingRoute ? <EditIcon /> : <AddIcon />}
            >
              {editingRoute ? "Update Route" : "Save Route"}
            </Button>
          </Grid>
        </Grid>
      </Card>

      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976D2" }}>
            <TableRow>
              <TableCell sx={{ color: "white" }}>Route Name</TableCell>
              <TableCell sx={{ color: "white" }}>Fee</TableCell>
              <TableCell sx={{ color: "white" }}>Fee Category</TableCell>
              <TableCell sx={{ color: "white" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {routes.map((route) => (
              <TableRow key={route.RouteID}>
                <TableCell>{route.RouteName}</TableCell>
                <TableCell>₹{route.Fee}</TableCell>
                <TableCell>{route.CategoryName}</TableCell>
                <TableCell>
                  <IconButton color="warning" onClick={() => handleEdit(route)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(route.RouteID)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default RoutePage;